import { render, staticRenderFns } from "./MiniCardTooltip.vue?vue&type=template&id=3c536ba2&scoped=true"
import script from "./MiniCardTooltip.vue?vue&type=script&lang=js"
export * from "./MiniCardTooltip.vue?vue&type=script&lang=js"
import style0 from "./MiniCardTooltip.vue?vue&type=style&index=0&id=3c536ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c536ba2",
  null
  
)

export default component.exports